'use client';

import { usePathname } from 'next/navigation';
import type { PropsWithChildren } from 'react';

import { DesktopPageShell } from '@/components/template/DesktopPageShell';

const PrivateMyLayout = ({ children }: PropsWithChildren) => {
  const pathname = usePathname();

  if (pathname?.startsWith('/my/point-market')) {
    return children;
  }

  return (
    <DesktopPageShell className="flex-1" mainClassName="flex min-h-0 flex-col">
      {children}
    </DesktopPageShell>
  );
};

export default PrivateMyLayout;
